/**
 * Constantes para Calendário
 * Compartilhado entre todos os projetos do monorepo
 */

/**
 * Dias da semana em português
 */
export const DiasSemanaPt = [
  'Domingo',
  'Segunda',
  'Terça',
  'Quarta',
  'Quinta',
  'Sexta',
  'Sábado',
] as const;

/**
 * Dias da semana abreviados
 */
export const DiasSemanaPtAbrev = [
  'Dom',
  'Seg',
  'Ter',
  'Qua',
  'Qui',
  'Sex',
  'Sáb',
] as const;

/**
 * Meses do ano em português
 */
export const MesesPt = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
] as const;

/**
 * Meses do ano abreviados
 */
export const MesesPtAbrev = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
] as const;

/**
 * Horários padrão para agendamentos (de hora em hora)
 */
export const HorariosPadraoAgenda = [
  '08:00',
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
] as const;

/**
 * Intervalos de tempo disponíveis (em minutos)
 */
export const IntervalosTempoDisponiveis = [
  { label: '15 minutos', valor: 15 },
  { label: '30 minutos', valor: 30 },
  { label: '45 minutos', valor: 45 },
  { label: '1 hora', valor: 60 },
  { label: '1h 30min', valor: 90 },
  { label: '2 horas', valor: 120 },
  { label: '3 horas', valor: 180 },
  { label: '4 horas', valor: 240 },
] as const;

/**
 * Configuração padrão do calendário
 */
export const CalendarioConfig = {
  locale: 'pt-BR',
  firstDayOfWeek: 0, // Domingo
  horaInicio: '08:00',
  horaFim: '20:00',
  intervaloMinutos: 30,
  diasSemanaTrabalho: [1, 2, 3, 4, 5], // Segunda a Sexta
} as const;

/**
 * Dias da semana estruturados para uso em selects/multiselects
 */
export const DiasSemanaOptions = [
  { id: 1, nome: 'Domingo', nomeAbreviado: 'Dom' },
  { id: 2, nome: 'Segunda-feira', nomeAbreviado: 'Seg' },
  { id: 3, nome: 'Terça-feira', nomeAbreviado: 'Ter' },
  { id: 4, nome: 'Quarta-feira', nomeAbreviado: 'Qua' },
  { id: 5, nome: 'Quinta-feira', nomeAbreviado: 'Qui' },
  { id: 6, nome: 'Sexta-feira', nomeAbreviado: 'Sex' },
  { id: 7, nome: 'Sábado', nomeAbreviado: 'Sáb' },
] as const;

export type DiaSemana = (typeof DiasSemanaPt)[number];
export type DiaSemanaPtAbrev = (typeof DiasSemanaPtAbrev)[number];
export type Mes = (typeof MesesPt)[number];
export type MesPtAbrev = (typeof MesesPtAbrev)[number];
export type HorarioPadrao = (typeof HorariosPadraoAgenda)[number];
